export default "__VITE_ASSET__G8b_XoQ0__"